import { ComponentProps } from "react";

const EmailOperator = (props: ComponentProps<"svg">) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.24854 8.12427L8.68744 9.62793C9.49222 10.1241 10.508 10.1241 11.3128 9.62793L13.7517 8.12427"
        stroke="currentColor"
        strokeWidth="1.34286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.49719"
        y="4.16431"
        width="15.0062"
        height="11.6715"
        rx="1.67857"
        stroke="currentColor"
        strokeWidth="1.34286"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4166 10C13.3463 10 11.6666 11.6797 11.6666 13.75C11.6666 15.8203 13.3463 17.5 15.4166 17.5C17.4869 17.5 19.1666 15.8203 19.1666 13.75C19.1666 11.6797 17.4869 10 15.4166 10Z"
        fill="currentColor"
      />
      <path
        d="M15.5268 16.2043C15.183 16.2043 14.8801 16.1418 14.6184 16.0168C14.3566 15.8878 14.1378 15.7179 13.9619 15.5069C13.7861 15.292 13.6533 15.0517 13.5634 14.786C13.4735 14.5203 13.4286 14.2487 13.4286 13.9713C13.4286 13.6939 13.4735 13.4243 13.5634 13.1625C13.6533 12.8968 13.7861 12.6584 13.9619 12.4475C14.1378 12.2365 14.3566 12.0684 14.6184 11.9434C14.8801 11.8145 15.183 11.75 15.5268 11.75C15.8706 11.75 16.1735 11.8145 16.4352 11.9434C16.697 12.0684 16.9158 12.2365 17.0917 12.4475C17.2675 12.6584 17.4003 12.8968 17.4902 13.1625C17.5801 13.4243 17.625 13.6939 17.625 13.9713C17.625 14.2487 17.5801 14.5203 17.4902 14.786C17.4003 15.0517 17.2675 15.292 17.0917 15.5069C16.9158 15.7179 16.697 15.8878 16.4352 16.0168C16.1735 16.1418 15.8706 16.2043 15.5268 16.2043ZM15.5268 15.671C15.773 15.671 15.9898 15.6241 16.1774 15.5303C16.3649 15.4365 16.5212 15.3095 16.6462 15.1493C16.7752 14.9891 16.8729 14.8075 16.9393 14.6043C17.0057 14.4011 17.0389 14.1901 17.0389 13.9713C17.0389 13.7564 17.0057 13.5493 16.9393 13.35C16.8729 13.1469 16.7752 12.9652 16.6462 12.805C16.5212 12.6448 16.3649 12.5178 16.1774 12.424C15.9898 12.3302 15.773 12.2833 15.5268 12.2833C15.2806 12.2833 15.0638 12.3302 14.8762 12.424C14.6887 12.5178 14.5304 12.6448 14.4015 12.805C14.2765 12.9652 14.1807 13.1469 14.1143 13.35C14.0479 13.5493 14.0147 13.7564 14.0147 13.9713C14.0147 14.1901 14.0479 14.4011 14.1143 14.6043C14.1807 14.8075 14.2765 14.9891 14.4015 15.1493C14.5304 15.3095 14.6887 15.4365 14.8762 15.5303C15.0638 15.6241 15.2806 15.671 15.5268 15.671Z"
        fill="white"
      />
    </svg>
  );
};

export default EmailOperator;
